import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { withRouter, useHistory, NavLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { numberFormat, findArrayObject, amountFormatOnly, isEmpty, getDateInStringDDMMMYYYY, numberWithCommas, numberWithCommasInput, checkNumberOnly, replaceCommas, sortByDisplay, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import { DialogTitle, TripActionDialogContent, DialogActions } from '../Dialog/Dialog';
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Switches,
  Autocomplete
} from 'mui-rff';
import {
  Typography,
  Paper,
  Link,
  Grid,
  Button,
  Card,
  Dialog,
  CardActions,
  CardContent,
  CssBaseline,
  MenuItem,
  InputAdornment,
  InputLabel,
  FormControl,
  CardHeader,
  TextField as TextInput,
  Checkbox,
  Box,
  Tabs,
  Tab
} from '@material-ui/core';
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import AmountInput from '../Inputs/AmountInput'
import { Form } from 'react-final-form';
import NotesIcon from '@material-ui/icons/Notes';
import {
  addPartyCharge,
} from "../../../store/actions/tripActionCreator";
import { getAllDrivers } from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces } from "../../../utils/utils"
import inputStyles from '../css/inputs'
import { trackDwebEvent } from '../../analytics';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import AddDriver from '../AddDialogComponent/AddDialogComponent';
import addStyles from '../css/addEditTrip';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { AddPersonIcon } from '../../../components/icons';
import { OnChange } from 'react-final-form-listeners';
import { data } from 'jquery';
import * as logger from '../../../logger';
import TextInputState from '../Inputs/TextInputState';
import { addBankDetails, checkIfscCode } from '../../../store/actions/OnlinePaymentActionCreators';
import { TOGGLE_LOADER } from '../../../store/constants';
import SuccessDialog from '../Verfication/SuccessDialog';
import FailureDialog from '../Verfication/FailureDialog';
import { createBankDetails } from "../../../store/actions/authActionCreators";


const useStyles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  dialogContent: {
    padding: '16px 24px'
  },
  switchLabel: {
    marginLeft: 0
  },
  switchControl: {
    marginTop: 16,
    marginBottom: 8
  },
  error: {
    color: 'red',
    marginBottom: 8
  },
  expenseTypeListItem: {
    padding: '12px 15px',
    minHeight: 46,
    margin: 0,
    maxHeight: 46,
    width: '100%'
  },
  addExpenseListItem: {
    padding: '12px 15px',
    margin: 0,
    backgroundColor: '#0b1323',
    color: '#fff',
    fontWeight: 300,
    minHeight: 46,
    width: '100%',
    maxHeight: 46
  },
  addExpenseIcon: {
    color: '#fff',
    marginRight: 10
  },
  cherveRightIcon: {
    marginLeft: 10,
    float: 'right',
    color: '#fff'
  },
  listBoxAutoCompelete: {
    margin: 0,
    padding: 0
  },
  listBoxOption: {
    padding: 0,
    minHeight: 46,
    maxHeight: 46,
    borderBottom: '1px solid #eaedf3',
    "&:first-child": {
    },
    "&:last-child": {
    }
  },
  popUpIndicator: {
    display: 'none'
  },
  infoDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  nameDiv: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16
  },
  subTitleSec: {
    marginBottom: 8,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  subTitleTxt: {
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(11, 19, 35, 0.5)"
  },
  driverDetailsDiv: {
    padding: "16px 24px",
    borderRadius: 8,
    border: "solid 1px #dcdcdc",
    backgroundColor: " #ededed",
    marginBottom: 24,
    marginTop: 2
  },
  titleV2: {
    fontSize: 14,
    fontWeight: 600,
    color: '#6b778c',
    marginBottom: 4
  },
  newInput: {
    backgroundColor: '#fff',
    border: "solid 1px #dedede",
    "& .MuiInputBase-input": {
      paddingTop: 12,
      paddingBottom: 12
    }
  },
  newInputIfsc: {
    backgroundColor: '#fff',
    border: "solid 1px #dedede",
    "& .MuiInputBase-input": {
      paddingTop: 12,
      paddingBottom: 12,
      textTransform: 'uppercase'
    }
  },
  formControlInput: {
    marginBottom: 16
  },
  saveButtonDisabled: {
    backgroundColor: '#dadada !important',
    color: '#5e636c !important',
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    fontSize: 14,
    fontWeight: 300,
    height: 36,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#dadada'
    }
  },
  cofirmNowButton: {
    marginLeft: 16,
    padding: '6px 30px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#09101e',
    fontSize: 14,
    fontWeight: 600,
    color: '#fff',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: "#09101e",
    }
  },
}));

const AddBankDetailsDialog = (props) => {
  let ifscRegex = "^[A-Z]{4}0[A-Z0-9]{6}$";
  const componentClasses = useStyles();
  const inputClasses = inputStyles();
  let submit
  const {
    user,
    type,
    selectedData,
    onConfirm,
    classes,
    open,
    onClose,
    onSave,
    defaultSelected,
    location,
    editData,
    onUpdateSuccess,
    confirmText,
    trip,
    vehicle,
    dispatchAddBankDetailsAction,
    dispatchValidateIfsc,
    calledFrom,
    allocatedAmountSingleSupplier,
    dispatchCreateBankDetails,
    ...other
  } = props;

  let pathValue = location && location.pathname ? location.pathname.split("/") : [];
  let tripDetails = user.singleTripData ? user.singleTripData : {};
  let tripId = tripDetails && tripDetails.id ? tripDetails.id : pathValue[pathValue.length - 1];
  const locationDetails = useLocation();
  const path = locationDetails && locationDetails.pathname ? locationDetails.pathname.split("/") : [];

  const [accountNumber, setAccountNumber] = React.useState("");
  const [confirmAccountNumber, setConfirmAccountNumber] = React.useState("");
  const [ifscCode, setIfscCode] = React.useState("");
  const [accountHolderName, setAccountHolderName] = React.useState("");
  const [ifscCodeValidation, setIfscCodeValidation] = React.useState(false);
  const [bankName, setBankName] = React.useState("");
  const [successCreation, setSuccessCreation] = useState(false);
  const [failureCreation, setFailureCreation] = useState(false);
  const [confirmDisabled, setConfirmDisabled] = useState(false);
  const [upiAddressValue, setUpiAddressValue] = useState("");

  const handleSuccessOpen = () => {
    setSuccessCreation(true)
  }
  const handleSuccessClose = () => {
    setSuccessCreation(false)
  }
  const handleFailureOpen = () => {
    setFailureCreation(true)
  }
  const handleFailureClose = () => {
    setFailureCreation(false)
  }
  const handleChange = (event, newValue) => {

  };
  const handleFormSave = (e) => {
  }
  const handleClose = (status) => {
    onClose(false);
    if (type == "SUPPLIER") {
      if (calledFrom == "singleTrip") {
        trackDwebEvent('Dweb STP Supplier payout add bank account cancelled', {
          trip_id: tripDetails && tripDetails.id ? tripDetails.id : "",
          trip_start_date: tripDetails && tripDetails.startDate ? tripDetails.startDate : "",
          supplier_id: tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : "",
          supplier_name: tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : "",
          trip_status: tripDetails && tripDetails.status ? tripDetails.status : "",
          vehicle_id: tripDetails && tripDetails.vehicle && tripDetails.vehicle.id ? tripDetails.vehicle.id : "",
          vehicle_number: tripDetails && tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : "",
          origin: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
          destination: tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : "",
          supplier_balance: tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : "",
          account_number: accountNumber ? accountNumber : "",
          confirm_account_number: confirmAccountNumber ? confirmAccountNumber : "",
          ifsc_code: ifscCode ? ifscCode : "",
          account_holder_name: accountHolderName ? accountHolderName : ""
        });
      } else if (calledFrom == "singleSupplier") {

        const path = locationDetails && locationDetails.pathname ? locationDetails.pathname.split("/") : [];
        const vendorIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

        trackDwebEvent('Dweb single supplier payout add bank account cancelled', {
          vendor_id: vendorIdValue ? vendorIdValue : "",
          vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
          // vendor_contact_number,
          vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
          supplier_payout_amount: allocatedAmountSingleSupplier ? allocatedAmountSingleSupplier : 0,
          bank_account_number: accountNumber ? accountNumber : "",
          ifsc_code: ifscCode ? ifscCode : "",
          account_holder_name: accountHolderName ? accountHolderName : ""
        })
      }
    } else if (type == "DRIVER") {
      trackDwebEvent('Dweb Driver payout add bank account cancelled', {
        driver_id: selectedData && selectedData.id ? selectedData.id : " ",
        driver_name: selectedData && selectedData.name ? selectedData.name : "",
        driver_balance: selectedData && selectedData.driverBalance ? selectedData.driverBalance : "",
        account_number: accountNumber ? accountNumber : "",
        confirm_account_number: confirmAccountNumber ? confirmAccountNumber : "",
        ifsc_code: ifscCode ? ifscCode : "",
        account_holder_name: accountHolderName ? accountHolderName : ""
      });
    } else if (type == "KHATA_SHOP") {
      trackDwebEvent('Dweb Driver payout add bank account cancelled', {
        shop_id: selectedData && selectedData.id ? selectedData.id : " ",
        shop_name: selectedData && selectedData.name ? selectedData.name : "",
        shop_balance: selectedData && selectedData.balance ? selectedData.balance : "",
        account_number: accountNumber ? accountNumber : "",
        confirm_account_number: confirmAccountNumber ? confirmAccountNumber : "",
        ifsc_code: ifscCode ? ifscCode : "",
        account_holder_name: accountHolderName ? accountHolderName : ""
      });
    }
  };
  const getSubTitle = (type) => {
    switch (type) {
      case "SUPPLIER":
        return "Supplier Name";
      case "KHATA_SHOP":
        return "Shop Name";
      case "DRIVER":
        return "Driver Name";
      case "CUSTOMER":
        return "Party Name";
      case "FASTTAG":
        return "Fastag Vehicle Number";
      default:
        return null
    }
  }
  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
    //window.alert(JSON.stringify(values, 0, 2));
    fetch("https://ifsc.razorpay.com/" + values.ifscCode)
      .then(function (response) {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      }).then(function (data) {
        let reqData = {
          "acc_number": values.accountNumber,
          "ifsc_code": values.ifscCode.toUpperCase(),
          "acc_holder_name": values.accountHolderName,
          "entity_type": type,
          "bank_name": bankName,
          "upi_address": values && values.upiAddress ? values.upiAddress : "",
          "entity_id": selectedData.id,
          "s3_link_passbook_cheque": ""
        }
        if (data && data.BANK) {
          reqData.bank_name = data.BANK;
        }

        if (calledFrom == "invoice") {

          dispatchCreateBankDetails(reqData,
            (data) => {
              if (data && data.status && data.status.code == 200) {
                logger.log('Add Bank Details Dialog Dweb', 'Create Bank Details Successfull');
                if (data && data.status && data.status.code == 200) {
                  sendSucces("Bank Account Added Successfully");
                  onSave(data && data.response && data.response.broker_verification_status ? data.response.broker_verification_status : false);
                } else {
                  onSave(false);
                }
              }
            },
            () => {
              logger.log('Add Bank Details Dialog Dweb', 'Create Bank Details Failed');
              onSave(false);
            }
          )

        } else {

          dispatchAddBankDetailsAction(reqData, (response) => {
            if (response && response.status && response.status.code == 200) {
              if (type == "SUPPLIER") {
                const vendorIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

                if (calledFrom == "singleTrip") {
                  trackDwebEvent('Dweb STP Supplier payout bank account created', {
                    trip_id: tripDetails && tripDetails.id ? tripDetails.id : "",
                    trip_start_date: tripDetails && tripDetails.startDate ? tripDetails.startDate : "",
                    supplier_id: tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : "",
                    supplier_name: tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : "",
                    trip_status: tripDetails && tripDetails.status ? tripDetails.status : "",
                    vehicle_id: tripDetails && tripDetails.vehicle && tripDetails.vehicle.id ? tripDetails.vehicle.id : "",
                    vehicle_number: tripDetails && tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : "",
                    origin: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
                    destination: tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : "",
                    supplier_balance: tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : "",
                    account_number: values && values.accountNumber ? values.accountNumber : "",
                    confirm_account_number: values && values.confirmAccountNumber ? values.confirmAccountNumber : "",
                    ifsc_code: values && values.ifscCode ? values.ifscCode : "",
                    account_holder_name: values && values.accountHolderName ? values.accountHolderName : "",
                    bank_account_id: response && response.response && response.response.id ? response.response.id : ""
                  });

                  if (response && response.response && !response.response.broker_verification_status) {
                    trackDwebEvent('Dweb STP Supplier payout bank account verification failed', {
                      trip_id: tripDetails && tripDetails.id ? tripDetails.id : "",
                      trip_start_date: tripDetails && tripDetails.startDate ? tripDetails.startDate : "",
                      supplier_id: tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : "",
                      supplier_name: tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : "",
                      trip_status: tripDetails && tripDetails.status ? tripDetails.status : "",
                      vehicle_id: tripDetails && tripDetails.vehicle && tripDetails.vehicle.id ? tripDetails.vehicle.id : "",
                      vehicle_number: tripDetails && tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : "",
                      origin: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
                      destination: tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : "",
                      supplier_balance: tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : "",
                      account_number: values && values.accountNumber ? values.accountNumber : "",
                      confirm_account_number: values && values.confirmAccountNumber ? values.confirmAccountNumber : "",
                      ifsc_code: values && values.ifscCode ? values.ifscCode : "",
                      account_holder_name: values && values.accountHolderName ? values.accountHolderName : "",
                      // bank_account_id: response && response.response && response.response.id ? response.response.id : ""
                    });
                  } else if (response && response.response && response.response.broker_verification_status) {
                    trackDwebEvent('Dweb STP Supplier payout bank account verified', {
                      trip_id: tripDetails && tripDetails.id ? tripDetails.id : "",
                      trip_start_date: tripDetails && tripDetails.startDate ? tripDetails.startDate : "",
                      supplier_id: tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : "",
                      supplier_name: tripDetails && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : "",
                      trip_status: tripDetails && tripDetails.status ? tripDetails.status : "",
                      vehicle_id: tripDetails && tripDetails.vehicle && tripDetails.vehicle.id ? tripDetails.vehicle.id : "",
                      vehicle_number: tripDetails && tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : "",
                      origin: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
                      destination: tripDetails && tripDetails.destinationLocation ? tripDetails.destinationLocation : "",
                      supplier_balance: tripDetails && tripDetails.vendorBalance ? tripDetails.vendorBalance : "",
                      account_number: values && values.accountNumber ? values.accountNumber : "",
                      confirm_account_number: values && values.confirmAccountNumber ? values.confirmAccountNumber : "",
                      ifsc_code: values && values.ifscCode ? values.ifscCode : "",
                      account_holder_name: values && values.accountHolderName ? values.accountHolderName : "",
                      // bank_account_id: response && response.response && response.response.id ? response.response.id : ""
                    });
                  }

                } else if (calledFrom == "singleSupplier") {
                  trackDwebEvent('Dweb single supplier payout add bank account successful', {
                    vendor_id: vendorIdValue ? vendorIdValue : "",
                    vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                    // vendor_contact_number,
                    vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                    supplier_payout_amount: allocatedAmountSingleSupplier ? allocatedAmountSingleSupplier : 0,
                    bank_account_number: accountNumber ? accountNumber : "",
                    ifsc_code: ifscCode ? ifscCode : "",
                    account_holder_name: accountHolderName ? accountHolderName : "",
                    bank_account_id: response && response.response && response.response.id ? response.response.id : ""
                  });

                  if (response && response.response && !response.response.broker_verification_status) {
                    trackDwebEvent('Dweb single supplier payout supplier bank account verification failed', {
                      vendor_id: vendorIdValue ? vendorIdValue : "",
                      vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                      // vendor_contact_number,
                      vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                      supplier_payout_amount: allocatedAmountSingleSupplier ? allocatedAmountSingleSupplier : 0,
                      bank_account_number: values && values.accountNumber ? values.accountNumber : "",
                      ifsc_code: values && values.ifscCode ? values.ifscCode : "",
                      account_holder_name: values && values.accountHolderName ? values.accountHolderName : ""
                    });
                  } else if (response && response.response && response.response.broker_verification_status) {
                    trackDwebEvent('Dweb single supplier payout suppier bank account verified', {
                      vendor_id: vendorIdValue ? vendorIdValue : "",
                      vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                      // vendor_contact_number,
                      vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                      supplier_payout_amount: allocatedAmountSingleSupplier ? allocatedAmountSingleSupplier : 0,
                      bank_account_number: accountNumber ? accountNumber : "",
                      ifsc_code: ifscCode ? ifscCode : "",
                      account_holder_name: accountHolderName ? accountHolderName : "",
                      bank_account_id: response && response.response && response.response.id ? response.response.id : ""
                    });
                  }
                }
              } else if (type == "DRIVER") {

                trackDwebEvent('Dweb Driver payout bank account created', {
                  driver_id: selectedData && selectedData.id ? selectedData.id : "",
                  driver_name: selectedData && selectedData.name ? selectedData.name : "",
                  driver_balance: selectedData && selectedData.driverBalance ? selectedData.driverBalance : "",
                  account_number: accountNumber ? accountNumber : "",
                  confirm_account_number: confirmAccountNumber ? confirmAccountNumber : "",
                  ifsc_code: ifscCode ? ifscCode : "",
                  account_holder_name: accountHolderName ? accountHolderName : "",
                  bank_account_id: response && response.response && response.response.id ? response.response.id : ""
                });

                if (response && response.response && response.response.broker_verification_status) {
                  trackDwebEvent('Dweb Driver payout bank account verified', {
                    driver_id: selectedData && selectedData.id ? selectedData.id : "",
                    driver_name: selectedData && selectedData.name ? selectedData.name : "",
                    driver_balance: selectedData && selectedData.driverBalance ? selectedData.driverBalance : "",
                    account_number: accountNumber ? accountNumber : "",
                    confirm_account_number: confirmAccountNumber ? confirmAccountNumber : "",
                    ifsc_code: ifscCode ? ifscCode : "",
                    account_holder_name: accountHolderName ? accountHolderName : "",
                    bank_account_id: response && response.response && response.response.id ? response.response.id : ""
                  });
                } else if (response && response.response && !response.response.broker_verification_status) {
                  trackDwebEvent('Dweb Driver payout bank account verification failed',
                    {
                      driver_id: selectedData && selectedData.id ? selectedData.id : "",
                      driver_name: selectedData && selectedData.name ? selectedData.name : "",
                      driver_balance: selectedData && selectedData.driverBalance ? selectedData.driverBalance : "",
                      account_number: accountNumber ? accountNumber : "",
                      confirm_account_number: confirmAccountNumber ? confirmAccountNumber : "",
                      ifsc_code: ifscCode ? ifscCode : "",
                      account_holder_name: accountHolderName ? accountHolderName : "",
                      bank_account_id: response && response.response && response.response.id ? response.response.id : ""
                    });
                }

              } else if (type == "KHATA_SHOP") {

                trackDwebEvent('Dweb Shop payout bank account created', {
                  shop_id: selectedData && selectedData.id ? selectedData.id : "",
                  shop_name: selectedData && selectedData.name ? selectedData.name : "",
                  shop_balance: selectedData && selectedData.balance ? selectedData.balance : "",
                  account_number: accountNumber ? accountNumber : "",
                  confirm_account_number: confirmAccountNumber ? confirmAccountNumber : "",
                  ifsc_code: ifscCode ? ifscCode : "",
                  account_holder_name: accountHolderName ? accountHolderName : "",
                  bank_account_id: response && response.response && response.response.id ? response.response.id : ""
                });

                if (response && response.response && response.response.broker_verification_status) {
                  trackDwebEvent('Dweb Shop payout bank account verified', {
                    shop_id: selectedData && selectedData.id ? selectedData.id : "",
                    shop_name: selectedData && selectedData.name ? selectedData.name : "",
                    shop_balance: selectedData && selectedData.balance ? selectedData.balance : "",
                    account_number: accountNumber ? accountNumber : "",
                    confirm_account_number: confirmAccountNumber ? confirmAccountNumber : "",
                    ifsc_code: ifscCode ? ifscCode : "",
                    account_holder_name: accountHolderName ? accountHolderName : "",
                    bank_account_id: response && response.response && response.response.id ? response.response.id : ""
                  });
                } else {
                  trackDwebEvent('Dweb Shop payout bank account verification failed',
                    {
                      shop_id: selectedData && selectedData.id ? selectedData.id : "",
                      shop_name: selectedData && selectedData.name ? selectedData.name : "",
                      shop_balance: selectedData && selectedData.balance ? selectedData.balance : "",
                      account_number: accountNumber ? accountNumber : "",
                      confirm_account_number: confirmAccountNumber ? confirmAccountNumber : "",
                      ifsc_code: ifscCode ? ifscCode : "",
                      account_holder_name: accountHolderName ? accountHolderName : "",
                      bank_account_id: response && response.response && response.response.id ? response.response.id : ""
                    });
                }

              }
              if (response && response.response && response.response.broker_verification_status) {
                sendSucces("Bank Account Added Successfully");
              }
              onSave(response && response.response && response.response.broker_verification_status ? response.response.broker_verification_status : false);

            } else {
              onSave(false);
            }
          }, (data) => {
            const vendorIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";
            onSave(false);
            if (type == "SUPPLIER") {
              if (calledFrom == "singleSupplier") {
                trackDwebEvent('Dweb single supplier payout add bank account failed', {
                  vendor_id: vendorIdValue ? vendorIdValue : "",
                  vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                  // vendor_contact_number,
                  vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                  supplier_payout_amount: allocatedAmountSingleSupplier ? allocatedAmountSingleSupplier : 0,
                  bank_account_number: values && values.accountNumber ? values.accountNumber : "",
                  ifsc_code: values && values.ifscCode ? values.ifscCode : "",
                  account_holder_name: values && values.accountHolderName ? values.accountHolderName : "",
                  failure_reason: data && data.status && data.status.message ? data.status.message : ""
                });
              }
            }

            if (type == "KHATA_SHOP") {

              trackDwebEvent('Dweb Shop payout bank account creation failed', {
                shop_id: selectedData && selectedData.id ? selectedData.id : "",
                shop_name: selectedData && selectedData.name ? selectedData.name : "",
                shop_balance: selectedData && selectedData.balance ? selectedData.balance : "",
                account_number: accountNumber ? accountNumber : "",
                confirm_account_number: confirmAccountNumber ? confirmAccountNumber : "",
                ifsc_code: ifscCode ? ifscCode : "",
                account_holder_name: accountHolderName ? accountHolderName : "",
              });
            }
          })
        }
      }, (err) => {
        handleFailureOpen();
      }).catch(function (error) {
      });
  };
  const validate = values => {
    const errors = {};

    let config = JSON.parse(localStorage.getItem("USER_APP_CONFIG"));
    let upiAddressValidation = config && config.upi_id_regex ? new RegExp(config.upi_id_regex) : "";
    let upiAddressLowerCase = values.upiAddress ? (values.upiAddress).toLowerCase() : "";
    //const accountNumberRegex = new RegExp("^[0-9]{9,18}$");
   // const accountNumberRegex = new RegExp("^(?![a-zA-z]*$)([a-zA-Z0-9]{9,18})+$");
   const accountNumberRegex = new RegExp("^[a-zA-Z0-9]{9,30}$");
    const accountHolderNameRegex = new RegExp("[A-Za-z]");

    if (!values.accountNumber) {
      errors.accountNumber = 'Please Enter a Account Number';
    }
    if (!values.accountNumber && !values.confirmAccountNumber) {
      errors.confirmAccountNumber = 'Please Enter a Account Number First';
    }
    if (values.accountNumber && !values.confirmAccountNumber) {
      errors.confirmAccountNumber = 'Please Enter a Account Number Again';
    }
    if (values.accountNumber && values.confirmAccountNumber
      && (values.accountNumber !== values.confirmAccountNumber)) {
      errors.confirmAccountNumber = 'Account No. and Confirm Account No. do not match';
    }

    if (values.accountNumber && (!accountNumberRegex.test(values.accountNumber))) {
      errors.accountNumber = "Invalid Account Number."
    }


    if (!values.ifscCode) {
      errors.ifscCode = 'Please Enter a IFSC Code';
    }
    /*if(values.ifscCode && !values.ifscCode.match(ifscRegex)){
      errors.ifscCode = 'Invalid IFSC Code Format';
    }*/
    if (values.ifscCode && ifscCodeValidation) {
      errors.ifscCode = 'Invalid IFSC Code';
    }
    if (!values.accountHolderName || (!accountHolderNameRegex.test(values.accountHolderName))) {
      errors.accountHolderName = "Please enter a valid name"
    }
    /*if(values.ifscCode && values.ifscCode.match(ifscRegex) && !ifscCodeValidation && !bankName){
      fetch("https://ifsc.razorpay.com/"+values.ifscCode)
      .then(response =>{
        if (!response.ok) {
          errors.ifscCode = 'Invalid IFSC Code';
          return errors
        }else{
          let data = response.json();
          setIfscCodeValidation(true)
          if(data && data.BANK){
            setBankName(data.BANK)
          }
          return errors
        }
      }).catch(function() {
      });
    }else{
      return errors;
    }*/

    if (values.upiAddress && !upiAddressValidation.test(upiAddressLowerCase)) {
      errors.upiAddress = "Please enter a Valid UPI Address"
    }

    if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
      setConfirmDisabled(true);
    } else {
      setConfirmDisabled(false);
    }

    return errors;
  }
  const getFormFields = (values) => {
    return [
      {
        size: 12,
        visible: true,
        inline: false,
        field: (
          <>
            <div className={componentClasses.titleV2}>Account Number *</div>
            <TextInputState
              className={componentClasses.formControlInput}
              placeholder="Enter a Account Number"
              name="accountNumber"
              margin="none"
              fullWidth={true}
              variant="outlined"
              size="small"
              onChange={(e) => {
                setAccountNumber((e.target.value).toUpperCase())
              }}
              InputProps={{
                className: componentClasses.newInput,
              }}
              required={true}
            />
          </>
        ),
      },
      {
        size: 12,
        visible: true,
        inline: false,
        field: (
          <>
            <div className={componentClasses.titleV2}>Confirm Account Number *</div>
            <TextInputState
              // label="Truck Hire Cost"
              className={componentClasses.formControlInput}
              placeholder="Confirm a Account Number"
              name="confirmAccountNumber"
              margin="none"
              fullWidth={true}
              variant="outlined"
              size="small"
              onChange={(e) => {
                setConfirmAccountNumber((e.target.value).toUpperCase())
              }}
              InputProps={{
                className: componentClasses.newInput,
              }}
              required={true}
            />
          </>
        ),
      },
      {
        size: 12,
        visible: true,
        inline: false,
        field: (
          <>
            <div className={componentClasses.titleV2}>IFSC Code *</div>
            <TextInputState
              // label="Truck Hire Cost"
              className={componentClasses.formControlInput}
              placeholder="Enter a IFSC Code"
              name="ifscCode"
              margin="none"
              fullWidth={true}
              variant="outlined"
              size="small"
              onChange={(e) => {
                setIfscCodeValidation(false)
                setIfscCode(e.target.value)
              }}
              onBlur={(e) => {
                fetch("https://ifsc.razorpay.com/" + values.ifscCode)
                  .then(function (response) {
                    if (!response.ok) {
                      throw Error(response.statusText);
                    }
                    return response.json();
                  }).then(function (data) {
                  }, (err) => {
                    setIfscCodeValidation(true)
                  }).catch(function (error) {
                  });
              }}
              InputProps={{
                className: componentClasses.newInputIfsc,
              }}
              required={true}
            />
          </>
        ),
      },
      {
        size: 12,
        visible: true,
        inline: false,
        field: (
          <>
            <div className={componentClasses.titleV2}>Account Holder Name *</div>
            <TextInputState
              // label="Truck Hire Cost"
              className={componentClasses.formControlInput}
              placeholder="Enter a Account Holder Name"
              name="accountHolderName"
              margin="none"
              fullWidth={true}
              variant="outlined"
              size="small"
              onChange={(e) => {
                setAccountHolderName(e.target.value)
              }}
              InputProps={{
                className: componentClasses.newInput,
              }}
              required={true}
            />
          </>
        ),
      },
      {
        size: 12,
        visible: calledFrom == "invoice" ? true : false,
        field: (
          <>
            <div className={componentClasses.titleV2}>UPI Address</div>
            <TextInputState
              // label="Truck Hire Cost"
              className={componentClasses.formControlInput}
              placeholder="Enter UPI Address"
              name="upiAddress"
              margin="none"
              fullWidth={true}
              variant="outlined"
              size="small"
              onChange={(e) => {
                setUpiAddressValue(e.target.value)
              }}
              InputProps={{
                className: componentClasses.newInput,
              }}
              required={true}
            />
          </>
        )
      }
    ]
  }
  let initialValues = {
    accountNumber: accountNumber,
    confirmAccountNumber: confirmAccountNumber,
    ifscCode: ifscCode,
    accountHolderName: accountHolderName,
    upiAddress: upiAddressValue
  };
  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth='xs'
        onClose={handleClose}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        aria-labelledby={"trip-actions-title-for-add-bank-details"}
        open={open}
      >
        <DialogTitle id={"trip-actions-title-for-add-bank-details"} onClose={handleClose}>
          {'Add Bank Account'}
        </DialogTitle>
        <TripActionDialogContent dividers>
          {calledFrom != "invoice" &&
            <div className={componentClasses.driverDetailsDiv}>
              <div className={componentClasses.subTitleSec} >
                <Typography className={componentClasses.subTitleTxt}>{getSubTitle(type)}</Typography>
              </div>
              <div className={componentClasses.infoDiv}>
                <div className={componentClasses.nameDiv}>
                  <Typography className={componentClasses.listDriverName}>
                    {selectedData && selectedData.name ? selectedData.name : selectedData && selectedData.vendorName ? selectedData.vendorName : ""}
                  </Typography>
                </div>
              </div>
            </div>
          }
          <Form
            onSubmit={onSubmit}
            initialValues={initialValues}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit; return (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid container alignItems="flex-start" spacing={0}>
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                </form>
              )
            }}
          />
        </TripActionDialogContent>
        <DialogActions>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button disabled={confirmDisabled} variant="contained" className={componentClasses.cofirmNowButton} onClick={event => submit(event)} >
            {confirmText ? confirmText : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>
      {successCreation && <SuccessDialog open={successCreation} title={"Success"} onClose={handleSuccessClose} />}
      {failureCreation && <FailureDialog open={failureCreation} title={"IFSC Code Failed"} subTitle={"Please Re-Check the Bank Account details"} onClose={handleFailureClose} />}
    </div>
  );
}
const AddBankDetailsDialogWithRouter = withRouter(AddBankDetailsDialog);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchAddBankDetailsAction: (data, onSuccess, onError) => dispatch(addBankDetails(data, onSuccess, onError)),
  dispatchValidateIfsc: (data, onSuccess, onError) => dispatch(checkIfscCode(data, onSuccess, onError)),
  dispatchCreateBankDetails: (accountData, onSuccess, onFailure) => {
    dispatch(createBankDetails(accountData, onSuccess, onFailure))
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddBankDetailsDialogWithRouter);
